var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "table",
      { staticClass: "table table-sm mt-0 table-hover table-striped" },
      [
        _c("thead", [
          _c("tr", [
            _vm.useCheckBox ? _c("td") : _vm._e(),
            _vm._v(" "),
            _c("td", { attrs: { width: "80px" } }, [
              _c("i", {
                class: {
                  "icon-fa pointer": true,
                  "icon-fa-sort-amount-asc":
                    _vm.sortingData.id.direction === "asc",
                  "icon-fa-sort-amount-desc":
                    _vm.sortingData.id.direction !== "asc",
                },
                on: {
                  click: function ($event) {
                    return _vm.sortOrders("id")
                  },
                },
              }),
              _vm._v("\n        Номер\n      "),
            ]),
            _vm._v(" "),
            _c("td", { attrs: { width: "250px" } }, [_vm._v("Клиент")]),
            _vm._v(" "),
            _c("td", { attrs: { width: "300px" } }, [_vm._v("Адрес")]),
            _vm._v(" "),
            _c("td", [_vm._v("Препараты")]),
            _vm._v(" "),
            _c("td", { attrs: { width: "80px" } }, [
              _c("i", {
                class: {
                  "icon-fa pointer": true,
                  "icon-fa-sort-amount-asc":
                    _vm.sortingData.price.direction === "asc",
                  "icon-fa-sort-amount-desc":
                    _vm.sortingData.price.direction !== "asc",
                },
                on: {
                  click: function ($event) {
                    return _vm.sortOrders("price")
                  },
                },
              }),
              _vm._v("\n        Сумма\n      "),
            ]),
            _vm._v(" "),
            _vm.type !== "doneByManager"
              ? _c("td", { attrs: { width: "170px" } }, [_vm._v("Курьер")])
              : _vm._e(),
            _vm._v(" "),
            _c("th"),
            _vm._v(" "),
            _c("td", { attrs: { width: "100px" } }, [
              _c("i", {
                class: {
                  "icon-fa pointer": true,
                  "icon-fa-sort-amount-asc":
                    _vm.sortingData.deliveryDateTimeStamp.direction === "asc",
                  "icon-fa-sort-amount-desc":
                    _vm.sortingData.deliveryDateTimeStamp.direction !== "asc",
                },
                on: {
                  click: function ($event) {
                    return _vm.sortOrders("deliveryDateTimeStamp")
                  },
                },
              }),
              _vm._v("\n        Дата доставки\n      "),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.localOrders, function (order) {
            return order.visible
              ? _c("tr", { key: order.id }, [
                  _vm.useCheckBox
                    ? _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedOrders[order.id],
                              expression: "selectedOrders[order.id]",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.selectedOrders[order.id])
                              ? _vm._i(_vm.selectedOrders[order.id], null) > -1
                              : _vm.selectedOrders[order.id],
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.selectedOrders[order.id],
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.selectedOrders,
                                      order.id,
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.selectedOrders,
                                      order.id,
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.selectedOrders, order.id, $$c)
                              }
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _vm._v("\n        " + _vm._s(order.id) + "\n        "),
                      _c("p", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$AllProjects[order.site_id]?.title ??
                                order.site_id
                            )
                          ),
                        ]),
                        _vm._v(
                          "\n          (" +
                            _vm._s(
                              (_vm.$AllCities[order.city_id] &&
                                _vm.$AllCities[order.city_id].short_name) ||
                                order.city_id
                            ) +
                            ")"
                        ),
                      ]),
                      _vm._v(" "),
                      (order.comment && order.comment.length) ||
                      order.reject_comment
                        ? [
                            _c("i", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: {
                                    content: _vm.getComments(order),
                                    placement: "bottom-center",
                                    classes: ["info custom-tooltip"],
                                    targetClasses: [
                                      "it-has-a-tooltip custom-tooltip",
                                    ],
                                    offset: 10,
                                    delay: {
                                      show: 200,
                                      hide: 700,
                                    },
                                  },
                                  expression:
                                    "{\n                  content: getComments(order),\n                  placement: 'bottom-center',\n                  classes: ['info custom-tooltip'],\n                  targetClasses: ['it-has-a-tooltip custom-tooltip'],\n                  offset: 10,\n                  delay: {\n                    show: 200,\n                    hide: 700\n                  }\n                }",
                                },
                              ],
                              staticClass:
                                "icon-fa icon-fa-info-circle comment_tooltip_fa",
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.printDate(order.created_at, "DD.MM.YYYY HH:mm")
                          ) +
                          "\n      "
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("p", [_vm._v(_vm._s(order.client_name))]),
                      _vm._v(" "),
                      order.is_customer_trusted
                        ? _c("p", [
                            _c("span", { staticClass: "badge badge-success" }, [
                              _vm._v(
                                "постоянный (" +
                                  _vm._s(order.is_customer_trusted) +
                                  ")"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(order.order_phones, function (phone, pi) {
                        return _c("div", [
                          _c(
                            "div",
                            { staticClass: "flex flex_gap_10" },
                            [
                              pi === 0 &&
                              phone.phone?.last_call &&
                              _vm.getTimeAgo(
                                phone.phone?.last_call.created_at,
                                order.delivery_date,
                                true
                              )
                                ? _c("MakeCall", {
                                    attrs: {
                                      phone: phone.phone,
                                      order: order,
                                      small: true,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.mixinPrintPhone(phone.phone.phone))
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          phone.phone?.last_call
                            ? _c("p", [
                                _vm._v("контакт\n            "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getTimeAgo(
                                        phone.phone?.last_call.created_at,
                                        pi === 0 ? order.delivery_date : null
                                      )
                                    ),
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ])
                      }),
                      _vm._v(" "),
                      order.extra_options?.noAnswerCallOrder
                        ? [
                            _c("span", { staticClass: "badge badge-warning" }, [
                              _vm._v("недозвонов: "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(order.extra_options.noAnswerCallOrder)
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      order.status === 1
                        ? _c("AgreementButton", {
                            attrs: {
                              text: "сменить дату",
                              component: "DeliveryDateChange",
                              order: order,
                            },
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "div",
                        { staticClass: "flex align-items-center" },
                        [
                          order.address
                            ? _c(
                                "v-popover",
                                {
                                  attrs: {
                                    "auto-hide": true,
                                    placement: "right",
                                    popoverClass: "order_address_map_popover",
                                    popoverInnerClass:
                                      "order_address_map_popover_inner",
                                    delay: { show: 500, hide: 500 },
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-xs btn-outline-info mr-1",
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon-fa icon-fa-map-marker",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "template",
                                    { slot: "popover" },
                                    [
                                      _c("AddressMap", {
                                        attrs: { orderId: order.id },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  (_vm.$AllCities[order.city_id] &&
                                    _vm.$AllCities[order.city_id].name) ||
                                    order.city_id
                                )
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(order.address))]),
                      _vm._v(" "),
                      _c("RunnerSalaryRate", {
                        attrs: { rate: order?.extra_options?.salary_rate ?? 0 },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    _vm._l(order.details, function (detail) {
                      return _c(
                        "div",
                        {
                          class: `drug_details ${_vm.getOrderClass(
                            order,
                            detail
                          )}`,
                        },
                        [
                          _c("p", { staticClass: "flex" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  detail.new_drug && detail.new_drug.title
                                ) +
                                " (" +
                                _vm._s(detail.drug_id) +
                                ")\n            "
                            ),
                            detail.new_drug && detail.new_drug.cool
                              ? _c("span", { staticClass: "ml-1" }, [
                                  _c("i", {
                                    staticClass: "icon icon-snowflake",
                                  }),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            detail.new_drug && detail.new_drug.pack_comment
                              ? _c("i", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content: detail.new_drug.pack_comment,
                                        placement: "bottom-center",
                                        classes: ["info"],
                                        targetClasses: ["it-has-a-tooltip"],
                                        offset: 20,
                                        delay: {
                                          show: 500,
                                          hide: 300,
                                        },
                                      },
                                      expression:
                                        "{\n                      content: detail.new_drug.pack_comment,\n                      placement: 'bottom-center',\n                      classes: ['info'],\n                      targetClasses: ['it-has-a-tooltip'],\n                      offset: 20,\n                      delay: {\n                        show: 500,\n                        hide: 300\n                      }\n                    }",
                                    },
                                  ],
                                  staticClass:
                                    "icon-fa icon-fa-info-circle ml-1",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            detail.new_drug && detail.new_drug.pack_box_comment
                              ? _c("i", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content:
                                          detail.new_drug.pack_box_comment,
                                        placement: "bottom-center",
                                        classes: ["info"],
                                        targetClasses: ["it-has-a-tooltip"],
                                        offset: 20,
                                        delay: {
                                          show: 500,
                                          hide: 300,
                                        },
                                      },
                                      expression:
                                        "{\n                      content: detail.new_drug.pack_box_comment,\n                      placement: 'bottom-center',\n                      classes: ['info'],\n                      targetClasses: ['it-has-a-tooltip'],\n                      offset: 20,\n                      delay: {\n                        show: 500,\n                        hide: 300\n                      }\n                    }",
                                    },
                                  ],
                                  staticClass:
                                    "icon-fa icon-fa-info-circle ml-1",
                                })
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          detail.pack_set !== 1
                            ? [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(
                                      "x " +
                                        _vm._s(detail.qty / detail.pack_set)
                                    ),
                                  ]),
                                  _vm._v(" (компл)"),
                                  _c("strong", [
                                    _vm._v(
                                      " * " +
                                        _vm._s(detail.price * detail.pack_set)
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _c("strong", [
                                    _vm._v("x " + _vm._s(detail.qty)),
                                  ]),
                                  _vm._v(" завод. упак."),
                                  _c("strong", [
                                    _vm._v(" * " + _vm._s(detail.price)),
                                  ]),
                                ]),
                              ]
                            : [
                                _c(
                                  "p",
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "x " +
                                          _vm._s(detail.qty) +
                                          " * " +
                                          _vm._s(detail.price)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.division?.settings?.currency_id &&
                                    _vm.division.settings.currency_id !== 33
                                      ? _c("CurrencyDrugPrice", {
                                          attrs: {
                                            drugData: detail,
                                            currency:
                                              _vm.$AllCurrencies[
                                                _vm.division.settings
                                                  .currency_id
                                              ],
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                          _vm._v(" "),
                          _vm.showStoreData
                            ? [
                                _c("p", [
                                  _vm._v(
                                    "По согласованных или предоплаченных заявках:\n              "
                                  ),
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: {
                                          content: _vm.printDebugDrugData(
                                            detail.drug_id
                                          ),
                                          placement: "bottom-center",
                                          classes: ["info"],
                                          autoHide: false,
                                          targetClasses: ["it-has-a-tooltip"],
                                          offset: -5,
                                          delay: {
                                            show: 500,
                                            hide: 500,
                                          },
                                        },
                                        expression:
                                          "{\n                      content: printDebugDrugData(detail.drug_id),\n                      placement: 'bottom-center',\n                      classes: ['info'],\n                      autoHide: false,\n                      targetClasses: ['it-has-a-tooltip'],\n                      offset: -5,\n                      delay: {\n                        show: 500,\n                        hide: 500\n                      }\n                    }",
                                      },
                                    ],
                                    staticClass:
                                      "icon-fa icon-fa-info-circle ml-1",
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("p", [_vm._v("без учета текущей заявки")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  _vm._l(
                                    [_vm.storeId, ..._vm.motherRelatedStores],
                                    function (s, i) {
                                      return _c(
                                        "span",
                                        { staticClass: "extra_store_block" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$AllStores[s].short_title
                                              ) +
                                              " :\n                "
                                          ),
                                          _c(
                                            "strong",
                                            [
                                              i === 0
                                                ? [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          (_vm.dynamicStoreData
                                                            .final[
                                                            detail.drug_id
                                                          ]?.[s] ?? 0) +
                                                            detail.qty
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                : [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dynamicStoreData
                                                          .final[
                                                          detail.drug_id
                                                        ]?.[s] ?? 0
                                                      )
                                                    ),
                                                  ],
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.appointedOrdersDrugs
                                  ? _c("div", [
                                      _vm._v(
                                        "\n              Наличие - транизит - назначенные:\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            (_vm.dynamicStoreData.stage_1[
                                              detail.drug_id
                                            ]?.[_vm.storeId] ?? 0) -
                                              (_vm.appointedOrdersDrugs[
                                                detail.drug_id
                                              ] ?? 0)
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "flex" }, [
                      _vm.sendMessageModal[order.id] &&
                      _vm.sendMessageModal[order.id].supervisor
                        ? _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-info btn-xs",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.sendTelegramMessage(
                                        order.id,
                                        "supervisorModal"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-user-secret",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.sendMessageModal[order.id].supervisorModal
                                ? _c("SendRunnerMessage", {
                                    attrs: {
                                      data: order,
                                      type: "supervisor",
                                      onModalClose: () =>
                                        (_vm.sendMessageModal[
                                          order.id
                                        ].supervisorModal = false),
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("PrePaidInfo", { attrs: { order: order } }),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(order.price))]),
                          _vm._v(" "),
                          order.currency_id && order.currency_id !== 33
                            ? _c("p", [
                                _vm._v(
                                  _vm._s(order.currency_id_price) +
                                    "\n              " +
                                    _vm._s(
                                      _vm.$AllCurrencies[order.currency_id]
                                        .currency
                                    )
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    order.discount
                      ? _c("div", [
                          _vm._v("\n          Скидка: "),
                          _c("strong", [_vm._v(_vm._s(order.discount))]),
                          _vm._v(
                            _vm._s(order.discount_type == 1 ? "%" : "руб") +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.type !== "doneByManager"
                    ? _c(
                        "td",
                        [
                          order.courier
                            ? [_c("p", [_vm._v(_vm._s(order.courier.name))])]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.type &&
                          _vm.type !== "doneByManager" &&
                          _vm.sendMessageModal[order.id] &&
                          _vm.sendMessageModal[order.id].runner
                            ? _c(
                                "div",
                                {},
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-outline-info btn-xs",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.sendTelegramMessage(
                                            order.id,
                                            "runnerModal"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon-fa icon-fa-motorcycle",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.sendMessageModal[order.id].runnerModal
                                    ? _c("SendRunnerMessage", {
                                        attrs: {
                                          data: order,
                                          type: "runner",
                                          onModalClose: () =>
                                            (_vm.sendMessageModal[
                                              order.id
                                            ].runnerModal = false),
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _vm.allowToShiftToPost && order.pay_method === 3
                        ? [
                            _c("LoadingButton", {
                              attrs: {
                                title: "На почту",
                                type: "button",
                                loading: _vm.postSendBtnLoading[order.id],
                                color: _vm.$constants.PRIMARY_COLOR,
                                onClick: () =>
                                  _vm.changeOrdersDivision(order.id),
                                className: "btn btn-outline-info",
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.storeId === 3 && _vm.allowToSendOrders
                        ? [
                            _c("LoadingButton", {
                              attrs: {
                                title: "На отправку",
                                type: "button",
                                loading: _vm.postSendBtnLoading[order.id],
                                color: _vm.$constants.PRIMARY_COLOR,
                                onClick: () => _vm.sendToPostDelivery(order.id),
                                className: "btn btn-outline-info",
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("p", [
                        _c(
                          "span",
                          {
                            class: {
                              "badge badge-warning":
                                _vm.getDeliveryDate(order).overdue,
                            },
                          },
                          [_vm._v(_vm._s(_vm.getDeliveryDate(order).date))]
                        ),
                      ]),
                      _vm._v(" "),
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-xs btn-info pull-left mr-2",
                            on: {
                              click: function ($event) {
                                return _vm.orderToEdit(order.id)
                              },
                            },
                          },
                          [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                        ),
                      ],
                    ],
                    2
                  ),
                ])
              : _vm._e()
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }